import { useLearnerPath } from '../../data/useLearnerPath';
import { GsaLearning } from '../GsaLearning';
import { DegreeLearning } from './DegreeLearning';

/**
 * Learning surface. One url, two views: a degree learner keeps the view their
 * programme was built around, everyone else gets the GSA one.
 *
 * An enrolled degree learner keeps `DegreeLearning` — this is the switch that
 * gives it to them. Only `'both'` falls to the GSA view, and set-edu cannot
 * create that learner, so nobody loses anything today; see
 * `pages/Program/index.tsx` for why it is left alone (PR #1120).
 *
 * The transcript is not at stake either way: it has its own route, and
 * `ROUTE_OWNER` lets `'both'` through it like every other route. What `'both'`
 * would miss here is the shared `Learning` view — programme enrollments,
 * planned courses, class enrollments, attendance and receipts.
 */
export const LearningPage = () => {
  const path = useLearnerPath();

  return path === 'degree' ? <DegreeLearning /> : <GsaLearning />;
};
